import {useDispatch, useSelector} from "react-redux";
import {
    getItemCount, getListViewNoImages,
    getShowListView, getShowNewUserModal,
    GRID_VIEW,
    LIST_VIEW,
    setDefaultView,
    setItemCount, setShowNewUserModal, setListViewNoImages
} from "@store/preferences.slice";

const usePreferences = () => {
    const dispatch = useDispatch();

    //Default View
    const showListView = useSelector(getShowListView);
    const setShowListView = (show:boolean) => {
        dispatch(setDefaultView(show ? LIST_VIEW : GRID_VIEW));
    };

    const showListViewNoImages = useSelector(getListViewNoImages);
    const setShowListViewNoImages = (noImages:boolean) => {
        dispatch(setListViewNoImages(noImages));
    };

    //Item count
    const itemCount = useSelector(getItemCount);
    const setDefaultItemCount = (count:number) => {
        dispatch(setItemCount(count));
    };

    //Show new user modal
    const showNewUserModal = useSelector(getShowNewUserModal);
    const handleSetShowNewUserModal = (show:boolean) => {
        dispatch(setShowNewUserModal(show));
    };

    return {
        showListView,
        setShowListView,
        itemCount,
        setItemCount: setDefaultItemCount,
        showNewUserModal,
        setShowNewUserModal: handleSetShowNewUserModal,
        showListViewNoImages,
        setShowListViewNoImages,
    };
}

export default usePreferences;